import { create, } from "zustand";
import { getDateInDays, } from "../utils";
import { devtools, } from "zustand/middleware";
import { ILimitResponse, IOperation, IUserProfileQueryResponse, } from "../api";

export const MODERATOR_LOCALSTORAGE_KEYS = {
  phone: "moderatorPhone",
  code: "moderatorCode",
};

interface IModeratorProfile extends IUserProfileQueryResponse {
  fullName?: string;
  nationality?: string;
  qr?: string;
}

interface IModeratorStoreState {
  isModerator: boolean;
  profile?: IModeratorProfile | null;
  limitsConfirmed?: ILimitResponse[];
  operations?: IOperation[];
  init: (phone: string) => void;
  setModeratorQR: (code: string) => void;
  reset: () => void;
}

export const moderatorStoreStoreInitialState = {
  isModerator: false,
  profile: null,
  limitsConfirmed: [],
  operations: [],
};

export const useModeratorStore = create<IModeratorStoreState>()(
  devtools(set => ({
    ...moderatorStoreStoreInitialState,
    reset: () => {
      set(moderatorStoreStoreInitialState, false, { type: "moderator-store/reset", },
      );
    },
    init: (phone,) => {
      set({
        isModerator: true,
        profile: {
          id: 0,
          phone,
          email: "vpetrov@tech.ru",
          fullName: "Петров Василий Васильевич",
          birthdate: "1 октября 1985 г.",
          nationality: "Россия",
          passportSeries: "1285",
          passportNumber: "678851",
          passportIssueDate: "19 октября 2005 г.",
          passportDivisionCode: "255-084",
          registrationAddressString: "г.Москва, ул.Заводская д 1 кв 10",
        },
        limitsConfirmed: [
          {
            id: "0",
            name: "Denum",
            totalAmount: 55000,
            availableAmount: 47000,
            currencyCode: "RUB",
            status: "CONFIRMED",
            // partnerId: "00000000-0000-0000-0000-000000000000", // нет в ILimitResponse
          },
        ],
        operations: [
          {
            id: 1,
            merchantName: "Denum",
            dateNextPayment: getDateInDays(14,),
            amount: 299900,
            termInfo: { value: "6", unit: "month", },
            operationStatus: 1, // 1,3 - активные, 2 - оплаченные
            smallIconLink: "",
            macrocategory: "",
            currencyCode: "RUB",
            createDate: "2025-12-31",
            // limitId: "00000000-0000-0000-0000-000000000000", // нет в IOperation
          },
          {
            id: 2,
            merchantName: "Denum",
            dateNextPayment: getDateInDays(17,),
            amount: 90100,
            termInfo: { value: "6", unit: "month", },
            operationStatus: 1,
            smallIconLink: "",
            macrocategory: "",
            currencyCode: "RUB",
            createDate: "2025-12-31",
          },
          {
            id: 3,
            merchantName: "Denum",
            dateNextPayment: getDateInDays(25,),
            amount: 410000,
            termInfo: { value: "4", unit: "month", },
            operationStatus: 1,
            smallIconLink: "",
            macrocategory: "",
            currencyCode: "RUB",
            createDate: "2025-12-31",
          },
          {
            id: 4,
            merchantName: "Denum",
            dateNextPayment: getDateInDays(20,),
            amount: 159900,
            termInfo: { value: "4", unit: "month", },
            operationStatus: 2,
            smallIconLink: "",
            macrocategory: "",
            currencyCode: "RUB",
            createDate: "2025-12-31",
          },
          {
            id: 5,
            merchantName: "Denum",
            dateNextPayment: getDateInDays(4,),
            amount: 725000,
            termInfo: { value: "6", unit: "month", },
            operationStatus: 2,
            smallIconLink: "",
            macrocategory: "",
            currencyCode: "RUB",
            createDate: "2025-12-31",
          },
        ],
      },
      false, { type: "moderator-store/init", },);
    },

    setModeratorQR: (qrCode: string,) => {
      set(state => ({
        profile: {
          ...state.profile,
          qr: qrCode,
        } as IModeratorProfile,
      }), false, { type: "moderator-store/setModeratorQR", },);
    },

  }), { name: "moderator-store", },),
);
